const defaultState = {
    loader: false,
    redirect: false,
    toast: { id: 'default', active: false, message: '', status: 'error' },
    table: {
        car: { marca: '', tipo: '', anno: '', vin: '', disponibilidad: '' },
    },
    menu: []
}

const ui = (state = defaultState, action) => {

    switch (action.type) {
        case 'LOADING': return { ...state, loader: action.status }
        case 'REDIRECT': return { ...state, redirect: action.status }
        case 'FETCH_MENUS': return { ...state, menu: action.menu }
        case 'ADD_TOAST': return { ...state, toast: { id: action.id, active: true, message: action.message, status: action.status } }
        case 'REMOVE_TOAST': return { ...state, toast: { id: 'default', active: false, message: '', status: 'error' } }
        case 'UPDATE_FILTER': return {
            ...state,
            table: {
                ...state.table,
                [action.table]: {
                    ...state.table[action.table],
                    [action.element]: action.value
                }
            }
        }
        case 'LOG_OUT': return defaultState
        default: return state
    }
}

export const getLoader = (state) => state.loader
export const getRedirect = (state) => state.redirect
export const getMenu = (state) => state.menu
export const getActiveToast = (state) => state.toast
export const getTableFilter = (state, table) => state.table[table]

export default ui